export default __webpack_public_path__ + "static/media/cancer.531c903d.png";